module.exports = __webpack_public_path__ + "images/application/b-search-white-56fd885d.svg";